import _jsx from '@babel/runtime/helpers/jsx';
import { useState, useEffect } from 'react';
import { AndesProvider } from '@andes/context';
import 'prop-types';
import CarouselSnapped, { CarouselSnappedSlide } from '@andes/carousel-snapped';
import CardBlogEntry from '@seo-frontend-components/card-blog-entry';

/**
 * CardBlogCarousel Component
 */
function CardBlogCarousel(props) {
  const namespace = 'seo-ui-card-blog-carousel';
  const DESKTOP = 'desktop';
  const {
    blogEntries,
    title,
    callToAction,
    jsDisabled,
    supportWebP,
    blogsToViewDefault,
    preload,
    lazyload,
    locale,
    mounted
  } = props;
  const [showCarousel, setShowCarousel] = useState(jsDisabled);
  useEffect(() => {
    if (blogEntries.length <= blogsToViewDefault) {
      setShowCarousel(false);
      return;
    }
    setShowCarousel(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogsToViewDefault]);
  const showLoadingComponent = (blog, index) => /*#__PURE__*/_jsx("div", {
    className: "container"
  }, "".concat(blog.title, "-").concat(index), /*#__PURE__*/_jsx("div", {
    className: "entry-column"
  }, void 0, /*#__PURE__*/_jsx(CardBlogEntry, {
    blog: blog,
    insideCarousel: true,
    jsDisabled: jsDisabled,
    supportWebP: supportWebP,
    preload: preload,
    deviceType: "desktop"
  })));
  const showLoadingComponents = () => blogEntries.map(blog => showLoadingComponent(blog));
  const carouselHeader = /*#__PURE__*/_jsx("div", {
    className: "header-container"
  }, void 0, /*#__PURE__*/_jsx("h2", {
    className: "title"
  }, void 0, title), callToAction && callToAction.url && /*#__PURE__*/_jsx("a", {
    href: callToAction.url
  }, void 0, /*#__PURE__*/_jsx("span", {
    className: "call-to-action"
  }, void 0, callToAction.text)));
  if (!showCarousel) {
    return /*#__PURE__*/_jsx("section", {
      className: "".concat(namespace)
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "menu-loading"
    }, void 0, carouselHeader, /*#__PURE__*/_jsx("div", {
      className: "carrousel-container"
    }, void 0, showLoadingComponents())));
  }
  return /*#__PURE__*/_jsx(AndesProvider, {
    locale: locale
  }, void 0, /*#__PURE__*/_jsx("section", {
    className: "".concat(namespace)
  }, void 0, /*#__PURE__*/_jsx(CarouselSnapped, {
    title: carouselHeader,
    srLabel: title,
    lazyload: lazyload,
    slidesPerView: blogsToViewDefault,
    spacing: 16,
    strictBoundaries: false,
    type: "content",
    pagination: false
  }, void 0, blogEntries.map((blog, index) => /*#__PURE__*/_jsx(CarouselSnappedSlide, {}, "".concat(blog.title, "-").concat(index), /*#__PURE__*/_jsx("div", {
    className: "entry-column"
  }, void 0, /*#__PURE__*/_jsx(CardBlogEntry, {
    blog: blog,
    insideCarousel: true,
    jsDisabled: jsDisabled,
    supportWebP: supportWebP,
    deviceType: DESKTOP,
    mounted: mounted,
    preload: index < blogsToViewDefault
  })))))));
}
CardBlogCarousel.defaultProps = {
  locale: 'es-AR',
  blogsToViewDefault: 4,
  callToAction: {
    url: '',
    text: ''
  },
  lazyload: true,
  preload: false,
  mounted: false
};

/**
 * Inject i18n context as props into CardBlogCarousel.
 */
CardBlogCarousel.displayName = 'CardBlogCarousel';
export { CardBlogCarousel as default };
